var _path, _path2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C4.69168 2 2 4.69154 2 8C2 11.3085 4.69168 14 8 14C11.3085 14 14 11.3085 14 8C14 4.69154 11.3083 2 8 2ZM8 13.1241C5.17461 13.1241 2.87591 10.8254 2.87591 8C2.87591 5.17461 5.17461 2.87591 8 2.87591C10.8254 2.87591 13.1241 5.17459 13.1241 7.99986C13.1241 10.8254 10.8254 13.1241 8 13.1241Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0437 8.00002H8.14593V5.37228C8.14593 5.13038 7.94987 4.93433 7.70797 4.93433C7.46607 4.93433 7.27002 5.13038 7.27002 5.37228V8.43797C7.27002 8.67987 7.46607 8.87593 7.70797 8.87593H10.0437C10.2856 8.87593 10.4817 8.67987 10.4817 8.43797C10.4817 8.19608 10.2856 8.00002 10.0437 8.00002Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.702aae13ed56ef93acd6f28374f48fc0.svg";
export { ForwardRef as ReactComponent };